var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{attrs:{"id":`select${_vm.selectId}`},on:{"change":_vm.selectChangeHandler}},_vm._l((_vm.items),function(item,index){return _c('option',{key:index,domProps:{"value":typeof item === 'object' ? item.value : item}},[_vm._v("\n    "+_vm._s(typeof item === 'object' ? _vm.$t(item.key) : _vm.$t(item))+"\n  ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }